module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "fronttitle paired"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('a', {
    attrs: {
      "href": "#/contents"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('a', {
    attrs: {
      "href": "#/front01"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('a', {
    attrs: {
      "href": "#/front02"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('a', {
    attrs: {
      "href": "#/front03"
    }
  }, [_vm._v("Map of Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "part"
  }, [_c('a', {
    attrs: {
      "href": "#/c001"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("A telephone call at dawn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("The red-haired professor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c03"
    }
  }, [_vm._v("Prelude")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c04"
    }
  }, [_vm._v("The snowball")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c05"
    }
  }, [_vm._v("There’s no one so silly as a clever man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c06"
    }
  }, [_vm._v("My last year")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c07"
    }
  }, [_vm._v("Life counted in minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c08"
    }
  }, [_vm._v("The year 1937 begins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c09"
    }
  }, [_vm._v("Expelled from the Party")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("That day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Vevers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The cellars at “Black Lake”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The investigators have conclusive evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stick and carrot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The walls come to life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Can you forgive me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “conveyor belt”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confrontations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New encounters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orphans twice over")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tukhachevsky and others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Moscow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transfer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to Butyrki")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The whole of the Comintern")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butyrki nights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In accordance with the law of December 1st")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“A fair and speedy trial”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Penal servitude—what bliss!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pugachev Tower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stolypin coach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five steps by three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major Weinstock’s twenty-two commandments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bright nights and dark days")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Glands dog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The underground punishment cell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comunista Italiana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Next year in Jerusalem”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day after day, month after month")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A breath of oxygen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A fire in prison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Punishment cell for the second time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memories of Giordano Bruno")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The end of the “monstrous dwarf”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Great expectations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A bathhouse! Just an ordinary bathhouse!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ruins of Schlüsselburg")])]), _vm._v(" "), _c('p', {
    staticClass: "part"
  }, [_c('span', {
    attrs: {
      "href": "#/c002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Car Number 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All sorts to make a world")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The transit camp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c52",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The")]), _vm._v(" S.S. Dzhurma")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No luck today, my lady Death!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elgen is the Yakut word for “dead”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tree felling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salvation from heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('span', {
    attrs: {
      "href": "#/back01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('span', {
    attrs: {
      "href": "#/back02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('span', {
    attrs: {
      "href": "#/back03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Connect with HMH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('span', {
    attrs: {
      "href": "#/footnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Footnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 57
// module chunks = 0